import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 43,
	viewBox: "0 0 44 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21.9999,
			cy: 21.5017,
			rx: 21.6308,
			ry: 20.9753,
			fill: "url(#paint0_linear_8010_23604)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5212 16.2568L20.4359 26.0365C20.0347 26.4256 19.3924 26.4103 19.0102 26.0025L14.7897 21.5007",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_8010_23604",
			x1: 3.39745,
			y1: -2.25349,
			x2: 41.0912,
			y2: 52.3532,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ABE7CE" }), /* @__PURE__ */ _jsx("stop", {
				offset: .562838,
				stopColor: "#3DD394"
			})]
		}) })
	]
});
export default SvgSuccessCheck;
